import { observable, decorate, action } from 'mobx';
import * as ErrorsUtils from '../utils/ErrorsUtils';
import services from '../utils/ServiceUtils';
import * as Endpoints from '../utils/Endpoints';
import ViewConstants from '../utils/ViewConstants';

class PreguntasSeguridadStore {
  conIcp;
  idChallenge;
  popupErrorSinacofi = { show: false };

  constructor(appstore) {
    this.appstore = appstore;
  }

  obtenerPreguntas = (rutCliente, numSerie, onResult, onFail) => {
    if (ViewConstants.ENABLE_RECAPTCHA === 'true') {
      this.appstore.recaptcha.execute('obtenerPreguntas').then((token) => {
        this.doObtenerPreguntas(rutCliente, numSerie, token, onResult, onFail);
      });
    } else {
      this.doObtenerPreguntas(rutCliente, numSerie, null, onResult, onFail);
    }
  };

  obtenerPreguntasOk = action('obtenerPreguntasOk', (response, onResult) => {
    this.idChallenge = response.data.idChallenge;
    this.conIcp = response.data.icp;

    const nuevas = (response.data.preguntas ?? []).map((p) =>
      observable({
        codigo: p.codigopregunta,
        pregunta: p.pregunta,
        alternativas: (p.alternativas ?? []).map((alt) =>
          observable({
            codigo: alt.codigorespuesta,
            respuesta: alt.respuesta,
          })
        ),
        respuestaSeleccionada: undefined,
      })
    );
    onResult(nuevas);
  });

  obtenerPreguntasFail = action('obtenerPreguntasFail', (err, onFail) => {
    if (err?.response?.status === 401) {
      ErrorsUtils.showSessionInvalida();
    } else if (err?.response) {
      this.showErrorSinacofi();
    } else {
      ErrorsUtils.showErrorFor(-99999);
    }
  });

  doObtenerPreguntas = async (rutCliente, numSerie, captchaToken, onResult, onFail) => {
    const timer = setTimeout(() => {
      this.appstore.showLoading('Buscando informacion para validar tu identidad');
    }, 500);

    const clearLoader = () => {
      clearTimeout(timer);
      this.appstore.hideLoading();
    };

    const obtieneEncriptacionAsync = () =>
      new Promise((resolve) => {
        this.appstore.obtieneEncriptacion((idkey, publicKey) => {
          resolve({ idkey, publicKey });
        });
      });

    try {
      const { idkey, publicKey } = await obtieneEncriptacionAsync();
      const serieEncriptado = await this.appstore.encripta(publicKey, numSerie, idkey);

      const response = await services.post(
        Endpoints.PREGUNTAS_ENDPOINT,
        { rutCliente },
        { 'x-validation': captchaToken, 'client-id-number': serieEncriptado }
      );

      clearLoader();
      this.obtenerPreguntasOk(response, onResult);
    } catch (err) {
      clearLoader();
      this.obtenerPreguntasFail(err, onFail);
    }
    if (onFail) {
      onFail();
    }
  };

  validarRespuestas = (rutCliente, respuestas, onResult) => {
    if (ViewConstants.ENABLE_RECAPTCHA === 'true') {
      this.appstore.recaptcha.execute('obtenerPreguntas').then((token) => {
        this.doValidarRespuestas(rutCliente, respuestas, token, onResult);
      });
    } else {
      this.doValidarRespuestas(rutCliente, respuestas, null, onResult);
    }
  };

  doValidarRespuestas = (rutCliente, respuestas, captchaToken, onResult) => {
    const timer = setTimeout(() => {
      this.appstore.showLoading('Estamos validando tus respuestas');
    }, 500);
    services
      .post(
        Endpoints.RESPUESTAS_ENDPOINT + '?icp=' + this.conIcp,
        {
          rutCliente: rutCliente,
          idChallenge: this.idChallenge,
          respuestas: respuestas,
        },
        { 'x-validation': captchaToken }
      )
      .then(
        action('validarRespuestasOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          services.setToken(response.data.sessionToken);
          if (onResult) {
            onResult();
          }
        })
      )
      .catch(
        action('validarRespuestasFail', (err) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          if (err.response) {
            const response = err.response;
            if (response.status) {
              if (response.status === 401) {
                ErrorsUtils.showSessionInvalida();
              } else {
                this.showErrorSinacofi();
              }
            } else {
              this.showErrorSinacofi();
            }
          } else {
            this.showErrorSinacofi();
          }
        })
      );
  };

  showErrorSinacofi = () => {
    this.popupErrorSinacofi.show = true;
  };

  hideErrorSinacofi = () => {
    this.popupErrorSinacofi.show = false;
  };
}

decorate(PreguntasSeguridadStore, {
  preguntas: observable,
  obtenerPreguntas: action,
  popupErrorSinacofi: observable,
  showErrorSinacofi: action,
  hideErrorSinacofi: action,
});
export default PreguntasSeguridadStore;
